import script from "./LedgerEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./LedgerEntry.vue?vue&type=script&setup=true&lang=js"

import "./LedgerEntry.vue?vue&type=style&index=0&id=fd28f33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd28f33a"]])

export default __exports__